import { render } from "./FavoritesView.vue?vue&type=template&id=13ad6df8"
import script from "./FavoritesView.vue?vue&type=script&lang=js"
export * from "./FavoritesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__